module.exports = __webpack_public_path__ + "d293b8e2e661137afdc213079c448696.eot";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-light.eot
// module id = 18
// module chunks = 0